import store from '@/store/store'
import useI18nGlobal from '@/utils/i18n';
const {i18n} = useI18nGlobal();
const { t } = i18n.global;
export default function (editor){

  async function _onAction(){
    await store.dispatch('quizzes/quizChoosingSet', true); // to hide additional media features
    await store.dispatch('mediaContent/setEditorActive', editor.id); // to insert image accordingly
  }

  editor.ui.registry.addIcon('quiz',
    `<svg viewBox="0 0 512 512" width="20" height="20"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M512 288c0 35.35-21.49 64-48 64c-32.43 0-31.72-32-55.64-32C394.9 320 384 330.9 384 344.4V480c0 17.67-14.33 32-32 32h-71.64C266.9 512 256 501.1 256 487.6C256 463.1 288 464.4 288 432c0-26.51-28.65-48-64-48s-64 21.49-64 48c0 32.43 32 31.72 32 55.64C192 501.1 181.1 512 167.6 512H32c-17.67 0-32-14.33-32-32v-135.6C0 330.9 10.91 320 24.36 320C48.05 320 47.6 352 80 352C106.5 352 128 323.3 128 288S106.5 223.1 80 223.1c-32.43 0-31.72 32-55.64 32C10.91 255.1 0 245.1 0 231.6v-71.64c0-17.67 14.33-31.1 32-31.1h135.6C181.1 127.1 192 117.1 192 103.6c0-23.69-32-23.24-32-55.64c0-26.51 28.65-47.1 64-47.1s64 21.49 64 47.1c0 32.43-32 31.72-32 55.64c0 13.45 10.91 24.36 24.36 24.36H352c17.67 0 32 14.33 32 31.1v71.64c0 13.45 10.91 24.36 24.36 24.36c23.69 0 23.24-32 55.64-32C490.5 223.1 512 252.7 512 288z"/></svg>`
  );

  editor.ui.registry.addButton('quiz', {
    tooltip: t('popup.quizzes.title'),
    icon: 'quiz',
    onAction: _onAction
  });

  editor.ui.registry.addMenuItem('quiz', {
    context: 'insert',
    text: t('popup.quizzes.title'),
    icon: 'quiz',
    onAction: _onAction
  });
}